import React from 'react';
import { Mail, Phone } from 'lucide-react';
import { ContactSectionProps } from '@/types';

const ContactSection: React.FC<ContactSectionProps> = ({ contactInfo }) => {
  return (
    <section id="contact" className="py-20">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
          Stay in Touch
        </h2>
        <p className="text-xl text-gray-300 mb-12">
          Feel free to reach out with questions about designing scalable and secure infrastructure solutions
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <a
            href={`mailto:${contactInfo.email}`}
            className="flex items-center gap-3 bg-gradient-to-r from-blue-500 to-purple-600 px-8 py-4 rounded-lg font-semibold hover:from-blue-600 hover:to-purple-700 transition-all duration-300 transform hover:scale-105"
          >
            <Mail className="w-5 h-5" />
            Email Me
          </a>
          <a
            href={`tel:${contactInfo.phone.replace(/[^\d]/g, '')}`}
            className="flex items-center gap-3 border border-gray-600 px-8 py-4 rounded-lg font-semibold hover:border-blue-500 hover:bg-blue-500/10 transition-all duration-300"
          >
            <Phone className="w-5 h-5" />
            Call Me
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;